import React,{useEffect} from 'react'
import Navbar from '../../layout/Navbar'
import Header from '../../layout/Header'
import MainBlogs from './MainBlogs'
import BlogsGem from './BlogsGem'
import Review from '../../layout/Review'
import DownloadSection from '../../layout/downloadSection'
import Footer from '../../layout/Footer'
import SEO, { getSEOData } from '../../components/SEO'

function Blogs() {
  const seo = getSEOData('blog');

  useEffect(() => {
    // Scroll to top when the pathname changes
    window.scrollTo(0, 0);
  }, []);
  
  return (
    <div className='blog'> 
     <SEO 
        title={seo.title.replace(' | Pulpit', '').replace('Pulpit - ', '')}
        description={seo.description}
        keywords={seo.keywords}
      />      
       <Navbar page="blog"></Navbar>
       {/* <Header></Header> */}
       {/* <MainBlogs></MainBlogs>
       <Review></Review>
       <DownloadSection></DownloadSection> */}
       <BlogsGem></BlogsGem>
       <Footer></Footer>
    </div>
  );
}

export default Blogs;